






















import { TimelineVisibleArea } from "@/data/models/TimelineSettings";
import { SchedulingModule } from "@/store/modules/SchedulingModule";
import { Component, Vue } from "vue-property-decorator";
import { DateTime } from "luxon";
import { formatDateWithWeekday } from "@/utils/DateFormatter";

@Component
export default class TimelineControlComponent extends Vue {
  get timelineConfiguration() {
    return SchedulingModule.timelineConfiguration;
  }

  get currentVisibleAreaDescription() {
    const { start, end, timelineSettings } = this.timelineConfiguration;

    const visibleArea = timelineSettings.visibleArea;

    if (visibleArea === TimelineVisibleArea.ONE_DAY) {
      return formatDateWithWeekday(start, {
        showTime: false,
        showYearIfNotCurrentYear: false,
      });
    } else {
      let value = DateTime.fromJSDate(start).toFormat("W");

      if (
        visibleArea === TimelineVisibleArea.TWO_WEEKS ||
        visibleArea === TimelineVisibleArea.FOUR_WEEKS
      ) {
        value += "-" + DateTime.fromJSDate(end).toFormat("W");
      }

      return this.$t("scheduling.timelineControl.formatCalendarWeek", [value]);
    }
  }

  moveForward() {
    this.onMoveInDirection(true);
  }

  moveBackward() {
    this.onMoveInDirection(false);
  }

  onMoveInDirection(forward: boolean) {
    const { start, timelineSettings } = this.timelineConfiguration;
    const { visibleArea, showWeekends } = timelineSettings;

    const factor = forward ? 1 : -1;

    let numDaysToMove: number;

    switch (visibleArea) {
      case TimelineVisibleArea.ONE_DAY:
        numDaysToMove = 1;
        break;
      case TimelineVisibleArea.ONE_WEEK:
        numDaysToMove = 7;
        break;
      case TimelineVisibleArea.TWO_WEEKS:
        numDaysToMove = 7;
        break;
      case TimelineVisibleArea.FOUR_WEEKS:
        numDaysToMove = 14;
        break;
    }

    let newStartDate = DateTime.fromJSDate(start)
      .startOf("day")
      .plus({
        days: factor * numDaysToMove,
      });

    const weekendDays = [6, 7];

    //Skip weekends if necessary
    while (
      visibleArea == TimelineVisibleArea.ONE_DAY &&
      !showWeekends &&
      weekendDays.includes(newStartDate.weekday)
    ) {
      newStartDate = newStartDate.plus({
        days: factor * numDaysToMove,
      });
    }

    SchedulingModule.setTimelineSettings({
      ...SchedulingModule.timelineSettings,
      startDate: newStartDate.toJSDate(),
    });
  }
}
